export default __webpack_public_path__ + "static/media/flag-tibet.70a7fb22.svg";